// import deepMerge from 'shadow-fns/deepMerge'
import isObject from './isObject'
import isArray from './isArray'

const deepMerge = (obj1, obj2, options) => {
  const { concatArrays } = Object(options)

  for (const key in obj2) {
    if (isObject(obj1[key]) && isObject(obj2[key])) {
      obj1[key] = deepMerge(obj1[key], obj2[key])
    } else if (isArray(obj1[key]) && isArray(obj2[key]) && concatArrays) {
      obj1[key] = [].concat(obj1[key], obj2[key])
    } else {
      obj1[key] = obj2[key]
    }
  }

  return obj1
}

export default deepMerge
